import React, { useState } from "react";
import "./mobile.scss";
import { AiOutlineForm } from "@react-icons/all-files/ai/AiOutlineForm";
import { FaWpforms } from "@react-icons/all-files/fa/FaWpforms";
import { AiOutlineMenu } from "@react-icons/all-files/ai/AiOutlineMenu";
import { MdDateRange } from "@react-icons/all-files/md/MdDateRange";
import { AiOutlinePartition } from "@react-icons/all-files/ai/AiOutlinePartition";
import { HiOutlineCheckCircle } from "@react-icons/all-files/hi/HiOutlineCheckCircle";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setClinicName } from "../../../redux/slices/clinicSlice";
import { setToken, setUserToken } from "../../../redux/slices/authSlice";
import { StorageHelpers } from "../../../core/Helpers";

const Mobile = () => {
  const [moreMenu, setMoreMenu] = useState(false);
  const token = useSelector((state) => state.authSlice.token);
  const dispatch = useDispatch();
  const logoutHandle = () => {
    StorageHelpers.removeAuthToken();
    StorageHelpers.removeUserAuthToken();
    dispatch(setToken(null));
    dispatch(setUserToken(null));
    dispatch(setClinicName(""));
  };
  return (
    <div className="min-h-full h-screen">
      <div className="w-screen h-24 absolute items-center flex bg-[#0077b6]">
        <AiOutlineMenu
          onClick={() => setMoreMenu(true)}
          className="text-white text-4xl mr-5"
        />
        <div className="flex justify-center">
          <Link className="" to="/request-list">
            <img className="w-72" src="/assets/images/logo.png" alt="logo" />
          </Link>
        </div>
      </div>
      <div
        className={`w-72 bg-[#0077b6] fixed duration-500 flex flex-col justify-between shadow-2xl h-full ${
          moreMenu ? "left-0" : "-left-[100%]"
        }`}
      >
        <div className="ml-8 mt-8 flex flex-col gap-6">
          <AiOutlineMenu
            onClick={() => setMoreMenu(false)}
            className="text-white text-4xl mr-5"
          />
          <div className="">
            <ul className="text-2xl flex gap-6 flex-col font-semibold text-white">
              {token !== null ? (
                <>
                  <Link
                    onClick={() => setMoreMenu(false)}
                    to="/request-list"
                    className="text-current hover:text-current"
                  >
                    <li className="flex items-center gap-2">
                      {" "}
                      <FaWpforms /> Taleplerim
                    </li>
                  </Link>
                  <Link
                    to="/select-patient"
                    onClick={() => setMoreMenu(false)}
                    className="text-current hover:text-current"
                  >
                    <li className="flex items-center gap-2 ">
                      <AiOutlineForm /> Ön Talep Formu
                    </li>
                  </Link>
                  <Link
                    onClick={() => setMoreMenu(false)}
                    to="/patients"
                    className="text-current hover:text-current"
                  >
                    <li className="flex items-center gap-2">
                      <AiOutlinePartition />
                      Hastalarım
                    </li>
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    onClick={() => setMoreMenu(false)}
                    to="/user-appointments"
                    className="text-current hover:text-current"
                  >
                    <li className="flex items-center gap-2">
                      <MdDateRange />
                      Randevularım
                    </li>
                  </Link>

                  <Link
                    onClick={() => setMoreMenu(false)}
                    to="/user-results"
                    className="text-current hover:text-current"
                  >
                    <li className="flex items-center gap-2">
                      <HiOutlineCheckCircle />
                      Sonuçlarım
                    </li>
                  </Link>
                </>
              )}
            </ul>
          </div>
        </div>
        <div className="justify-center flex mb-6">
          <button
            onClick={logoutHandle}
            className="bg-red-600 p-4 w-48 font-semibold text-white rounded-md"
          >
            Çıkış Yap
          </button>
        </div>
      </div>
    </div>
  );
};

export default Mobile;
